import { render, staticRenderFns } from "./UserFormFields.vue?vue&type=template&id=6c284c11"
import script from "./UserFormFields.vue?vue&type=script&lang=js"
export * from "./UserFormFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports